import React from 'react'
import className from 'classnames/bind'

import style from './MyhouseNotifyToggle.module.scss'

import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import ArrowRight7x17 from '@Ui/images/myhouse/ArrowRight7x17.svg'
import { MODAL_TYPE } from '@Root/contants/myhouseModal'
import useModal from '@Hooks/myhouse/useModal'
import MyhouseTooltipLayer from '@Components/atoms/MyhouseTooltipLayer'
import { handleNclickMix } from '@Helpers/nclick'

const cx = className.bind(style)

type Props = {
  houseNo?: any
  name?: any
  descType?: any
  title?: any
  description?: any
  isToggleType?: any
  isToggle?: any
  actionTitle?: any
  actionType?: any // ROUTE, MODAL
  initValue?: any
  handleClick?: any
  tooltipType?: any
  nclickTooltip?: string
  nclickAction?: string
}

const MyhouseNotifyToggle: React.FC<Props> = ({
  houseNo,
  name,
  descType,
  title,
  description,
  isToggleType,
  isToggle,
  actionTitle,
  actionType,
  initValue,
  handleClick,
  tooltipType,
  nclickTooltip,
  nclickAction,
}: Props) => {
  const { open } = useModal()

  const tooltipDescription = (type: any) => {
    if (type === 'newArticle') {
      //신규매물 DB에 없는 주택
      return '우리집과 <em style="color: #3b7cf5">동일한 법정동 내에 유사한 면적(±10%), 동일 거래타입(매매/전세/월세)의 신규 매물</em>이 발생한 경우에 전송되는 알림입니다.<br />동일한 조건(단지/면적/거래타입)의 우리집을 중복으로 등록한 경우, 신규 매물 알림 설정 시 동일 조건의 우리집 개수만큼 알림이 중복되어 전송됩니다. 이때, 토글버튼을 on/off하여 하나의 우리집만 알림 발송 설정해 주시면 알림을 하나만 받을 수 있습니다.'
    } else if (type === 'newArticleEnrolled') {
      //신규매물 DB등록된 주택
      return '우리집과 <em style="color: #3b7cf5">동일 단지, 동일 면적, 동일 거래타입(매매/전세/월세)의 신규 매물</em>이 발생한 경우에 전송되는 알림입니다.<br />동일한 조건(단지/면적/거래타입)의 우리집을 중복으로 등록한 경우, 신규 매물 알림 설정 시 동일 조건의 우리집 개수만큼 알림이 중복되어 전송됩니다. 이때, 토글버튼을 on/off하여 하나의 우리집만 알림 발송 설정해 주시면 알림을 하나만 받을 수 있습니다.'
    } else if (type === 'newRealPrice') {
      //신규 실거래가
      return '우리집과 <em style="color: #3b7cf5">동일 단지, 동일 면적, 동일 거래타입(매매/전세/월세)의 신규 실거래가</em>가 발생한 경우에 전송되는 알림입니다.<br /> 동일한 조건(단지/면적/거래타입)의 우리집을 중복으로 등록한 경우, 신규 실거래가 알림 설정 시 동일 조건의 우리집 개수만큼 알림이 중복되어 전송됩니다. 이때, 토글버튼을 on/off하여 하나의 우리집만 알림 발송 설정해 주시면 알림을 하나만 받을 수 있습니다.'
    }
  }

  return (
    <div className={cx('myhouse_notify_item', !descType && isToggleType === 'TOGGLE' && 'type_toggle')}>
      <div className={cx('myhouse_notify_info')}>
        <span className={cx('myhouse_info_title')}>
          {title}
          {!!tooltipType && <MyhouseTooltipLayer title={title} description={tooltipDescription(tooltipType)} isSetting nclickOpen={nclickTooltip} />}
        </span>
        {descType && <span className={cx('myhouse_info_text', 'type_message')}>네이버앱을 통해 알림이 전송됩니다.</span>}
      </div>
      {isToggleType === 'ACTION' ? (
        <>
          {actionType === 'ROUTE' && (
            <a href={`${LAND_SERVICE_PREFIX_URL.MYHOUSE_REGISTER}/main/${houseNo}`} className={cx('myhouse_notify_link')} onClick={handleNclickMix(nclickAction)}>
              {actionTitle}
              <ArrowRight7x17 />
            </a>
          )}
          {actionType === 'MODAL' && (
            <a
              href="#"
              className={cx('myhouse_notify_link')}
              onClick={() => {
                open(MODAL_TYPE.INSURANCE_REQUIRED)
              }}
            >
              {actionTitle}
              <ArrowRight7x17 />
            </a>
          )}
        </>
      ) : (
        <span className={cx('myhouse_toggle_button')}>
          <input name={name} id={`myhouse_input_` + name} type="checkbox" className={cx('myhouse_toggle_input')} checked={initValue || ''} onChange={(e) => handleClick(e)} />
          {/* checked상태일때 aria-label="알림 받기" 로 적용 */}
          <label htmlFor={`myhouse_input_` + name} className={cx('myhouse_toggle_label')} aria-label={initValue === true ? '알림 받기' : '알림 받지않기'}></label>
        </span>
      )}
    </div>
  )
}

export default MyhouseNotifyToggle
